import { TFunction } from 'next-i18next';
import { Category, DEFAULT_PRE_SERVICES, PRE_SERVICE_LICENCE_TYPE } from '@root/src/types';
import InputText from '@features/ui-input/components/InputText';
import InputYesNo from '@features/ui-input/components/InputYesNo';
import PreServiceInsurance from '@features/subscriptions/components/PreServiceInsurance';
import InputVIP from '@features/ui-input/components/InputVIP';
import InputCertificateUpload from '@features/ui-input/components/InputCertificateUpload';

const preServicesInputFactory = (fieldType: DEFAULT_PRE_SERVICES, t: TFunction, category: Category) => {
  switch (fieldType) {
    case DEFAULT_PRE_SERVICES.EMERGENCY_NUMBER_MANDATORY:
    case DEFAULT_PRE_SERVICES.EMERGENCY_NUMBER:
      return {
        'data-qa': 'subscriptions-preServicesEmergencyNumber-input',
        name: DEFAULT_PRE_SERVICES.EMERGENCY_NUMBER,
        label: t('preServicesInputFactory_emergencyNumberLabel.message'),
        key: fieldType,
        as: InputText,
        required: fieldType === DEFAULT_PRE_SERVICES.EMERGENCY_NUMBER_MANDATORY,
        showRequiredChip: fieldType === DEFAULT_PRE_SERVICES.EMERGENCY_NUMBER_MANDATORY,
      };

    case DEFAULT_PRE_SERVICES.CLUB_MANDATORY:
    case DEFAULT_PRE_SERVICES.CLUB:
      return {
        'data-qa': 'subscriptions-preServicesClub-input',
        name: DEFAULT_PRE_SERVICES.CLUB,
        label: category.team ? t('preServicesInputFactory_teamLabel.message') : t('preServicesInputFactory_clubLabel.message'),
        as: InputText,
        key: fieldType,
        required: fieldType === DEFAULT_PRE_SERVICES.CLUB_MANDATORY,
        showRequiredChip: fieldType === DEFAULT_PRE_SERVICES.CLUB_MANDATORY,
      };
    case DEFAULT_PRE_SERVICES.LICENSE_MANDATORY:
    case DEFAULT_PRE_SERVICES.LICENSE:
      if (category.preServices.license
        && category.preServices.licenseMandatory
        && category.preServices.licenseType === PRE_SERVICE_LICENCE_TYPE.CAS) {
        // If it's ask for a license CAS the input is useless because info already comme from the user profile
        return null;
      }
      return {
        'data-qa': 'subscriptions-preServicesLicense-input',
        name: DEFAULT_PRE_SERVICES.LICENSE,
        label: t('preServicesInputFactory_licenseLabel.message'),
        as: InputText,
        key: fieldType,
        required: fieldType === DEFAULT_PRE_SERVICES.LICENSE_MANDATORY,
        showRequiredChip: fieldType === DEFAULT_PRE_SERVICES.LICENSE_MANDATORY,
      };
    case DEFAULT_PRE_SERVICES.INSURANCE:
      return {
        'data-qa': 'subscriptions-preServicesInsurance-input',
        name: DEFAULT_PRE_SERVICES.INSURANCE,
        label: t('preServicesInputFactory_insuranceLabel.message'),
        as: InputYesNo,
        isInitialized: true,
        key: fieldType,
        checkboxLabel: t('preServicesInputFactory_insuranceCheckboxLabel.message'),
        descriptionComponent: <PreServiceInsurance />,
        descriptionOrder: 'column-reverse',
      };
    case DEFAULT_PRE_SERVICES.VIP:
      return {
        'data-qa': 'subscriptions-preServicesVIP-input',
        name: DEFAULT_PRE_SERVICES.VIP,
        label: t('preServicesInputFactory_vipLabel.message'),
        as: InputVIP,
        key: fieldType,
        clearable: true,
        disabled: true,
        required: true,
        validationChip: true,
      };
    case DEFAULT_PRE_SERVICES.FILE_UPLOAD_MANDATORY:
      return {
        'data-qa': 'subscriptions-preServicesFileUpload-input',
        name: DEFAULT_PRE_SERVICES.FILE_UPLOAD_MANDATORY,
        label: t('preServicesInputFactory_fileUploadLabel.message'),
        as: InputCertificateUpload,
        key: fieldType,
        required: true,
        showRequiredChip: true,
        acceptedTypes: ['image/jpeg', 'image/png', 'application/pdf'],
        maxSizeInMB: 10,
        description: category.fileUploadDescription,
        documentationUrl: category.preServices?.fileUploadDocumentationUrl,
      };
    default:
      return null;
  }
};

export default preServicesInputFactory;
